import { FC } from 'react';
import { img } from '@/helpers/utils';
import FingerUpIcon from '@/assets/svg/ico_finger_up.svg?react';
import BottomButtonsBlock from '@/components/blocks/BottomButtonsBlock/BottomButtonsBlock.component';
import Button from '@/components/controls/Button/Button.component';
import GallerySourceForm from '@/components/forms/GallerySourceForm/GallerySourceForm.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import {
    ADVICES,
    IMAGE_GUID,
} from '@/components/widgets/AddPhotoWidget/PhotoAdviceModal/PhotoAdviceModal.config';
import styles from '@/components/widgets/AddPhotoWidget/PhotoAdviceModal/PhotoAdviceModal.module.scss';
import { PhotoAdviceModalPropsIF } from '@/components/widgets/AddPhotoWidget/PhotoAdviceModal/PhotoAdviceModal.types';

const PhotoAdviceModal: FC<PhotoAdviceModalPropsIF> = ({
    addFiles,
    onclose,
}) => {
    const addFilesHandler = (files: File[]): void => {
        addFiles(files);
        onclose(false, true);
    };

    return (
        <ModalSheet onClose={onclose} dataTest="photo_advice_modal">
            <div className="flcol gapBlock">
                <h2 className={styles.title}>
                    Как получить <br />
                    лучший результат
                </h2>
                <div
                    className={`bgc ${styles.image}`}
                    style={{
                        backgroundImage: `url(${img(IMAGE_GUID)})`,
                    }}
                >
                    <div className={`flc ${styles.icon}`}>
                        <FingerUpIcon />
                    </div>
                </div>

                <div className={styles.description}>
                    {ADVICES.map((advice, index) => (
                        <div
                            className={`flcol gapButton ${styles.containerNumber}`}
                            key={advice}
                        >
                            <div className={`flc ${styles.adviceNumber}`}>
                                {index + 1}
                            </div>
                            <p>{advice}</p>
                        </div>
                    ))}
                </div>
                <BottomButtonsBlock position="static" className="gapBlock">
                    <GallerySourceForm
                        className={`flc ${styles.sourceButton}`}
                        buttonVariant="accent"
                        addFiles={addFilesHandler}
                        isMulti
                    >
                        Выбрать фото
                    </GallerySourceForm>
                    <Button
                        className={styles.infoButton}
                        dataTest="show_more_requirements_button"
                        clickHandler={() => onclose(true)}
                        isCustom
                    >
                        Подробнее о требованиях
                    </Button>
                </BottomButtonsBlock>
            </div>
        </ModalSheet>
    );
};

export default PhotoAdviceModal;
